import { z } from 'zod'
import { ORDER_MODIFICATION_REJECTION_REASON_MAX } from '~/services/api/contracts/bounds/ORDER_MODIFICATION_REJECTION_REASON_MAX'
import type { NoContext } from '~/services/api/contracts/NoContext'
import {
  OrderModificationActionSchema,
  PartnerOrderModificationRequestReviewRequestSchema
} from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const normalize = fieldNormalizer({
  enums: [{ field: 'action', options: OrderModificationActionSchema.options }],
  blankToNull: ['rejection_reason']
})

const schema = PartnerOrderModificationRequestReviewRequestSchema.extend({
  rejection_reason: z.string().max(ORDER_MODIFICATION_REJECTION_REASON_MAX).nullish()
}).strict()

export const PartnerOrderModificationRequestReview = (
  _context: NoContext
): z.ZodType<z.output<typeof schema>> => z.preprocess(normalize, schema)
